export default "__VITE_ASSET__BVwdJGDx__"